import classNames from "classnames";

import { ignoreAttribute } from "@ascendnow/shared";

import styles from "./AscCrosswordPuzzleClueList.module.scss";

export type AscCrosswordPuzzleClue = {
  clue: string;
  wordIndex: number;
};
export interface AscCrosswordPuzzleClueListProps {
  className?: string;
  cluesAcross?: AscCrosswordPuzzleClue[];
  cluesDown?: AscCrosswordPuzzleClue[];
  acrossLabel?: string;
  downLabel?: string;
}

export default function AscCrosswordPuzzleClueList({
  className,
  acrossLabel = "Across",
  downLabel = "Down",
  cluesAcross,
  cluesDown,
}: AscCrosswordPuzzleClueListProps) {
  return (
    <div
      data-testid={`asc-crossword-puzzle-clue-list`}
      className={classNames(styles.ground, className)}
      {...ignoreAttribute.contrast}
    >
      {cluesAcross?.length ? (
        <div className={styles.clueList}>
          <div className={styles.clueTitle}>{acrossLabel}</div>
          {cluesAcross?.map((clue) => (
            <div className={styles.clueItem} key={clue?.wordIndex}>
              <span>{clue?.wordIndex}</span>

              <span>{clue?.clue}</span>
            </div>
          ))}
        </div>
      ) : null}
      {cluesDown?.length ? (
        <div className={styles.clueList}>
          <div className={styles.clueTitle}>{downLabel}</div>
          {cluesDown?.map((clue) => (
            <div className={styles.clueItem} key={clue?.wordIndex}>
              <span>{clue?.wordIndex}</span>

              <span>{clue?.clue}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
